<template>
  <div id="broadcasting"></div>
</template>

<script>
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { normalizeServerUrl } from "@/utils/urlHelper.js";

export default {
  name: "Broadcasting",
  data() {
    return {
      echo: null,
    };
  },

  computed: {
    loggedIn: function () {
      return this.$store.getters["auth/isLoggedIn"];
    },
    token: function () {
      return this.$store.getters["auth/userToken"];
    },
    isConnected: function () {
      return (
        this.echo && this.echo.connector.pusher.connection.connection !== null
      );
    },
  },
  watch: {
    loggedIn: {
      handler: function (loggedIn) {
        if (loggedIn) {
          this.connect();
        } else {
          this.disconnect();
        }
      },
    },
    isConnected() {
      this.$emit("socketStatus", this.echo);
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.connect();
    }
  },
  methods: {
    connect() {
      if (!this.echo) {
        // Use ws:// for localhost, wss:// for production
        const isLocalhost =
          process.env.VUE_APP_WSHOST === "localhost" ||
          process.env.VUE_APP_WSHOST === "127.0.0.1";
        const useEncryption = !isLocalhost;

        this.echo = new Echo({
          broadcaster: "pusher",
          key: process.env.VUE_APP_PUSHER_APP_KEY,
          cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
          encrypted: useEncryption,
          wsHost: process.env.VUE_APP_WSHOST,
          wsPort: process.env.VUE_APP_WSPORT,
          wssHost: process.env.VUE_APP_WSHOST,
          wssPort: process.env.VUE_APP_WSPORT,
          disableStats: true,
          enabledTransports: ["ws", "wss"],
          forceTLS: useEncryption,
          authEndpoint:
            normalizeServerUrl(process.env.VUE_APP_DEVSERVER) +
            "/broadcasting/auth",
          auth: {
            headers: {
              Authorization: null,
            },
          },
        });
        this.echo.connector.pusher.connection.bind("connected", (event) => {
          // console.log("🔍 [WebSocket] Connected successfully", event);
          console.log("[broad] : Websocket Connected Succesfully");
          this.connect(event);
        });
        this.echo.connector.pusher.connection.bind("disconnected", () => {
          console.log("🔍 [WebSocket] Disconnected");
          this.disconnect();
        });
        this.echo.connector.pusher.connection.bind("error", (error) => {
          console.error("🔍 [WebSocket] Connection error:", error);
        });
        this.echo.connector.pusher.connection.bind("failed", () => {
          console.error("🔍 [WebSocket] Connection failed");
        });
      }
      this.echo.connector.options.auth.headers.Authorization = this.token;
      // console.log(
      //   "🔍 [WebSocket] Connecting with token:",
      //   this.token ? "Token present" : "NO TOKEN!"
      // );
      // console.log(
      //   "🔍 [WebSocket] Auth endpoint:",
      //   this.echo.connector.options.authEndpoint
      // );
      this.echo.connector.pusher.connect();
    },
    disconnect() {
      if (!this.echo) {
        return;
      } else {
        this.echo.disconnect();
        this.$emit("logout");
      }
    },
  },
};
</script>
